<script>
import store from '@state/store'
import Layout from '@layouts/loggedin.vue'
import PostFeed from '@router/components/post-feed.vue'
import { authComputed } from '@state/helpers'

export default {
  components: {
    Layout,
    PostFeed,
  },
  props: {
    interestId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loadingMore: false,
      noMorePosts: false,
    }
  },
  computed: {
    ...authComputed,
    statusUpdates() {
      return this.$store.state.interests.statusUpdates || []
    },
    interest() {
      return this.$store.state.interests.interest || []
    },
  },
  methods: {
    isFollowed() {
      var found = false
      for (let index = 0; index < this.currentUser.tags.length; index++) {
        if (this.currentUser.tags[index].id === this.interestId) {
          found = true
        }
      }
      return found
    },
    toggleFollowInterest() {
      store
        .dispatch('interests/toggleFollowInterest', {
          interestId: this.interestId,
          type:
            this.interest.type === undefined
              ? undefined
              : this.interest.type + 's',
          entity: this.interest.type === undefined ? 'Cause' : 'Tag',
          isFollowed: this.isFollowed(),
        })
        .then(() => {})
        .catch(() => {})
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    fetchMoreStatusUpdates() {
      this.loadingMore = true
      store
        .dispatch('interests/fetchStatusUpdates', {
          interestId: this.interestId,
          type: 'tag',
        })
        .then((posts) => {
          this.loadingMore = false
          this.noMorePosts = !posts.length
        })
        .catch(() => {})
    },
  },
}
</script>

<template>
  <Layout>
    <div class="pl-15 pr-20 flex justify-between bg-white">
      <div class="w-new-post relative z-10">
        <div class="mt-7 text-xl">
          <span class="capitalize">{{
            interest.type !== undefined ? interest.type : 'Cause'
          }}</span>
          <span class="breadcrumb-separator">></span>
          <span class="text-blue">{{ interest.name }}</span>
        </div>
      </div>
      <div class="text-right">
        <button
          class="mt-5 button primary-button h-12 block w-48 flex justify-between mb-4"
          @click="toggleFollowInterest"
          ><span class="align-middle">{{
            isFollowed() ? 'Unfollow' : 'Follow'
          }}</span></button
        >
      </div>
    </div>
    <div class="h-auto flex mt-16 pl-15 pr-15 justify-center w-content">
      <div class="left-posts w-7/12 bg-white rounded-xl shadow-box relative">
        <PostFeed
          :status-updates="statusUpdates"
          :loading-more="loadingMore"
          :no-more-posts="noMorePosts"
          @fetch-more-status-updates="fetchMoreStatusUpdates"
        ></PostFeed>
      </div>
    </div>
  </Layout>
</template>
